import { useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
// import { COLOR_WHITE } from '../../const';
import { images } from "../../images/index";

function CarouselScreen({ isTitleBannerCms }) {
    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };

    return (
        <Carousel activeIndex={index} onSelect={handleSelect} controls={false}>
            {bannerDatas.map((item, index) => (
                <Carousel.Item key={index} style={{ height: "100%", maxHeight: "60vh", width: "100%",   }}>
                    <img src={item?.image} alt={item?.title} className="w-100 h-100" />
                    {/* {isTitleBannerCms && <Carousel.Caption>
                        <h3 style={{ color: COLOR_WHITE, fontWeight: "bold" }}>{item.title}</h3>
                    </Carousel.Caption>} */}
                </Carousel.Item>
            ))}
        </Carousel>
    );
}

export default CarouselScreen;

const bannerDatas = [
    {
        title: "Product 01",
        image: images?.banner_show_v1,
    },
    {
        title: "Product 02",
        image: images?.banner_show_v2,
    },
    {
        title: "Product 03",
        image: images?.banner_show_v3,
    },

]